module.exports = __webpack_public_path__ + "img/logo-stag.27630c6d.png";